import { createIcon } from '@chakra-ui/react';

export const PeopleGroupFilled = createIcon({
  displayName: 'PeopleFilled',
  viewBox: '0 0 12 6.35',
  path: (
    <path
      id="Avatars_People_Group_Filled_-_S-2"
      data-name="Avatars People Group Filled - S"
      d="M6.527,6.171A1.535,1.535,0,1,0,4.991,4.635,1.535,1.535,0,0,0,6.527,6.171Zm3.367-.132A1.338,1.338,0,1,0,8.567,4.7,1.338,1.338,0,0,0,9.894,6.039Zm-6.734,0a1.327,1.327,0,1,0-.949-.389,1.338,1.338,0,0,0,.949.389Zm1.1.537a5.6,5.6,0,0,0-1.1-.132,6.416,6.416,0,0,0-1.228.143,1.36,1.36,0,0,0-1.1.954L.561,8.573A.252.252,0,0,0,.8,8.891H3l.307-1.1A1.8,1.8,0,0,1,4.333,6.577Zm8.258,2-.274-1.031a1.36,1.36,0,0,0-1.152-.954,6.3,6.3,0,0,0-1.217-.143,5.725,5.725,0,0,0-1.1.132,1.8,1.8,0,0,1,.987,1.2l.307,1.1h2.193a.252.252,0,0,0,.285-.3Zm-3.29-.658A1.535,1.535,0,0,0,7.9,6.818a7.052,7.052,0,0,0-1.371-.175,7.151,7.151,0,0,0-1.4.165A1.535,1.535,0,0,0,3.8,7.9L3.467,9.088a.285.285,0,0,0,.274.362H9.312a.285.285,0,0,0,.274-.362Z"
      transform="translate(-0.552 -3.1)"
      fill="#4d4d4d"
    />
  ),
});
